import {AuditData} from './AuditData';

export class ModificationInfo {

  public creation?: AuditData;
  public edition?: AuditData;
  public deletion?: AuditData;
}
